import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('machinery-types', options)



// WEBPACK FOOTER //
// ./src/store/modules/machinery-types.store.js